import { yupResolver } from "@hookform/resolvers/yup";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Button from "../../../../components/Common/Button/Button";
import Input from "../../../../components/Common/Input/Input";
import PlusIcon from "../../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import PreviousIcon from "../../../../components/Common/SvgIcons/CommonIcons/PreviousIcon";
import { FaSave } from "react-icons/fa";
import TabLinks from "../../../../components/Common/TabLinks/TabLinks";
import AddQuizAnswerArr from "../../../../components/Manage/CreateShotClass/AddQuizAnswerArr/AddQuizAnswerArr";
import AddQuizQuestionArr from "../../../../components/Manage/CreateShotClass/AddQuizQuestionArr/AddQuizQuestionArr";
import { createShotclasses } from "../../../../utils/mainTabs/manage/createShotclasses";
import { addQuizSchema } from "../../../../utils/mainTabs/manage/createShotclassSchema";
import classes from "./AddQuiz.module.scss";
import SelectThumbnail from "../../../../containers/manage/CreateShotClass/SelectThumbnail/SelectThumbnail";
import {
  copyShotclassActionHandler,
  createShotclassActionHandler,
  updateShotclassActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../../../store/actions/actionCreators/loadersActionCreator";
import { submisssions } from "../../../../utils/mainTabs/social/submissions";
import { setShotClassFormData } from "../../../../store/actions/actionCreators/socialActionCreator";
import deleteQuizQuestion from "../../../../api/manage/deleteQuizQuestion";
import { FormattedMessage } from "react-intl";
import { moderateContributions } from "../../../../utils/mainTabs/social/moderateContributions";
// import { usePrompt } from "../../../../hooks/preventNavigationHook";

const AddQuiz = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();

  const {
    tenantName,
    initialFormState,
    formValues,
    setFormValues,
    setManageTiles,
    shotclassType,
    managePath,
    createShotclassesPath,
    shotclassTypeFrom,
  } = useOutletContext();

  const manageState = useSelector((state) => state.manageReducer);
  const { saveAsADraftLoader } = manageState;
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;

  //1-main form, 2-thumbnail upload
  const [activeSection, setActiveSection] = useState(1);
  const [activeTab, setActiveTab] = useState(1);
  const [isEditQuestion, setIsEditQuestion] = useState(false);
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [activeThumbnailName, setActiveThumbnailName] = useState("");
  const [saveTrue, setSaveTrue] = useState(false);
  const [normalExit, setNormalExit] = useState(false);
  const [disableTabsOnValid, setDisableTabsOnValid] = useState(false);

  let buttonTexts = useMemo(() => {
    return {
      addSurvey: "Next",
      publish: "Publish",
    };
  }, []);
  const [nextButtonText, setNextButtonText] = useState(buttonTexts.addSurvey);
  const methods = useForm({
    defaultValues: {
      ...formValues.addQuiz,
    },
    mode: "onChange",
    resolver: yupResolver(addQuizSchema),
  });

  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    control,
    trigger,
    watch,
    getValues,
    setValue,
    clearErrors,
  } = methods;
  let answerTabs = [
    {
      id: 1,
      name: <FormattedMessage id="CREATE_MUTIPLECHOICE_TEXT" />,
      disabled:
        // ((shotclassType === "edit" || shotclassType === "copy") &&
        //   activeQuestionIndex <
        //     formValues?.Other?.AssessmentSet?.QuestionList?.length) ||
        // shotclassType === "view" ||
        isEditQuestion || disableTabsOnValid || formValues?.disableTabsOnValid,
    },
    {
      id: 2,
      name: <FormattedMessage id="CREATE_QUIZ_T&F_TEXT" />,
      disabled:
        // ((shotclassType === "edit" || shotclassType === "copy") &&
        //   activeQuestionIndex <
        //     formValues?.Other?.AssessmentSet?.QuestionList?.length) ||
        // shotclassType === "view" ||
        isEditQuestion || disableTabsOnValid || formValues?.disableTabsOnValid,
    },
    // { id: 3, name: "Fill In The Blanks" },
  ];
  const questionListWatch = watch("QuestionsList");
  // append, prepend, remove, swap, move, insert
  const {
    fields: questionsFields,
    append: appendQuestion,
    remove: removeQuestion,
    move: moveQuestion,
    update: updateQuestion,
  } = useFieldArray({
    control,
    name: "QuestionsList",
  });

  const addQuizCompleted = useCallback(
    (isCompleted) => {
      if (
        location?.pathname?.includes(moderateContributions?.path(tenantName))
      ) {
        const mode = location.pathname.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
        )
          ? "viewShotclasses"
          : "updateShotclasses";
        let updatedTiles = submisssions
          ?.tiles(navigate, location, params, mode, tenantName)
          .map((tile) => {
            if (
              tile.path ===
              `${submisssions.shotClassespath(
                params,
                location,
                tenantName
              )}/details`
            ) {
              return { ...tile, isCompleted: true };
            } else if (
              tile.path ===
                `${submisssions.shotClassespath(
                  params,
                  location,
                  tenantName
                )}/addSurvey` &&
              formValues?.addSurvey?.TotalQuestionCount > 0
            ) {
              return { ...tile, isCompleted: true };
            } else if (
              tile.path ===
              `${submisssions.shotClassespath(
                params,
                location,
                tenantName
              )}/addQuiz`
            ) {
              return { ...tile, isCompleted: true };
            } else {
              return { ...tile, isCompleted: false };
            }
          });
        setManageTiles(updatedTiles);
      } else {
        let updatedTiles = createShotclasses
          .tiles(navigate, location, params, tenantName)
          .map((tile) => {
            if (
              tile.path === `${createShotclassesPath}/details` ||
              tile.path ===
                `${submisssions.shotClassespath(
                  params,
                  location,
                  tenantName
                )}/details`
            ) {
              return { ...tile, isCompleted: true };
            } else if (
              (tile.path === `${createShotclassesPath}/addSurvey` ||
                tile.path ===
                  `${submisssions.shotClassespath(
                    params,
                    location,
                    tenantName
                  )}/addSurvey`) &&
              formValues?.addSurvey?.TotalQuestionCount > 0
            ) {
              return { ...tile, isCompleted: true };
            } else if (
              tile.path === `${createShotclassesPath}/addQuiz` ||
              tile.path ===
                `${submisssions.shotClassespath(
                  params,
                  location,
                  tenantName
                )}/addQuiz`
            ) {
              return { ...tile, isCompleted: true };
            } else {
              return { ...tile, isCompleted: false };
            }
          });
        setManageTiles(updatedTiles);
      }
    },
    [
      tenantName,
      createShotclassesPath,
      formValues?.addSurvey?.TotalQuestionCount,
      navigate,
      location,
      params,
      setManageTiles,
    ]
  );

  const handleClearAll = useCallback(() => {
    // reset(() => initialFormState.addQuiz);
    // setFormValues((formValues) => {
    //   return {
    //     ...formValues,
    //     addQuiz: initialFormState.addQuiz,
    //   };
    // });
    // setActiveTab(1);
    // setActiveQuestionIndex(() => 0);
    // setIsEditQuestion(false);

    //mukesh code
    if (
      activeQuestionIndex >= 0 ||
      (activeQuestionIndex === 0 && questionListWatch.length > 1)
    ) {
      clearErrors(); // Clear all errors
      const updatedQuestions = questionsFields.map((field, index) => {
        if (index === activeQuestionIndex) {
          return {
            Question: "",
            QuestionImage: "",
            ActiveQuestionType: 1,
            IsCorrect: "",
            MultiSelect: false,
            Explanation: "",
            AnswersList: [
              { Answer: "", AnswerImage: "" },
              { Answer: "", AnswerImage: "" },
            ],
          };
        }
        return field;
      });
      reset({ QuestionsList: updatedQuestions });
      setActiveTab(1);
      setIsEditQuestion(false);
      setDisableTabsOnValid(false);

      setFormValues((formValues) => {
        return {
          ...formValues,
          disableTabsOnValid: false,
        };
      });
    }
    if (activeQuestionIndex === 0 && questionListWatch.length === 1) {
      reset(() => initialFormState.addQuiz);
      setFormValues((formValues) => {
        return {
          ...formValues,
          addQuiz: initialFormState.addQuiz,
        };
      });
      setActiveTab(1);
      setActiveQuestionIndex(() => 0);
      setIsEditQuestion(false);
    }
    // }, [initialFormState.addQuiz, reset, setFormValues]);

    //mukesh dependency
  }, [
    activeQuestionIndex,
    reset,
    //clearErrors,
    questionsFields,
    setActiveTab,
    setIsEditQuestion,
    setActiveQuestionIndex,
  ]);

  useEffect(() => {
    if (formValues?.Other?.IsDistributed) {
      if (
        formValues?.Other?.ShotClassType === 3 ||
        formValues?.Other?.ShotClassType === 5
      ) {
        setNextButtonText(buttonTexts.addSurvey);
      } else if (
        formValues?.Other?.ShotClassType === 2 ||
        formValues?.Other?.ShotClassType === 6
      ) {
        setNextButtonText(buttonTexts.publish);
      }
      // if (formValues?.addSurvey?.TotalQuestionCount > 0) {
      //   setNextButtonText(buttonTexts.addSurvey);
      // } else if (formValues?.addSurvey?.TotalQuestionCount === 0) {
      //   setNextButtonText(buttonTexts.publish);
      // }
    }
  }, [
    buttonTexts,
    formValues?.Other?.IsDistributed,
    formValues?.addSurvey?.TotalQuestionCount,
    formValues?.Other?.ShotClassType,
  ]);

  useEffect(() => {
    if (formValues?.addQuiz?.TotalQuestionCount > 0) {
      setActiveQuestionIndex(() => -1);
    } else {
      addQuizCompleted(false);
      setActiveQuestionIndex(() => 0);
    }
  }, [formValues?.addQuiz?.TotalQuestionCount, addQuizCompleted]);

  useEffect(() => {
    if (formValues?.addQuiz?.QuestionsList?.length === 0) {
      reset(() => initialFormState.addQuiz);
      setFormValues((formValues) => {
        return {
          ...formValues,
          addQuiz: initialFormState.addQuiz,
        };
      });
    }
  }, [
    formValues?.addQuiz?.QuestionsList?.length,
    initialFormState.addQuiz,
    reset,
    setFormValues,
  ]);

  const handleSkipQuiz = () => {
    if (
      location?.pathname?.includes(
        `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
      ) ||
      location?.pathname?.includes(
        `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`
      )
    ) {
      setFormValues((formValues) => {
        return {
          ...formValues,
          disableTabsOnValid:
            formValues?.addSurvey?.TotalQuestionCount == 0 ? false : true,
        };
      });
      navigate(
        `${submisssions.shotClassespath(
          params,
          location,
          tenantName
        )}/addSurvey`
      );
    } else {
      setFormValues((formValues) => {
        return {
          ...formValues,
          disableTabsOnValid:
            formValues?.addSurvey?.TotalQuestionCount == 0 ? false : true,
        };
      });
      navigate(`${createShotclassesPath}/addSurvey`);
    }
  };

  const onSubmit = (data) => {
    addQuizCompleted(true);
    setFormValues((formValues) => {
      return {
        ...formValues,
        addQuiz: {
          ...formValues.addQuiz,
          ...data,
          PassingMarks: data?.PassingMarks,
          TotalQuestionCount: data?.QuestionsList?.length,
        },
        disableTabsOnValid:
          formValues?.addSurvey?.TotalQuestionCount == 0 ? false : true,
      };
    });
    if (
      location?.pathname?.includes(
        `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
      ) ||
      location?.pathname?.includes(
        `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`
      )
    ) {
      dispatch(
        setShotClassFormData({
          ...formValues,
          addQuiz: {
            ...formValues.addQuiz,
            ...data,
            TotalQuestionCount: data?.QuestionsList?.length,
          },
        })
      );
      navigate(
        `${submisssions.shotClassespath(
          params,
          location,
          tenantName
        )}/addSurvey`
      );
    } else {
      if (nextButtonText === buttonTexts.addSurvey) {
        navigate(`${createShotclassesPath}/addSurvey`);
      } else if (nextButtonText === buttonTexts.publish) {
        navigate(`${createShotclassesPath}/publishShotclass`);
      }
    }
  };

  const saveQuestion = () => {
    if (shotclassType === "view") {
      setActiveQuestionIndex((_) => -1);
    } else {
      trigger().then(() => {
        if (isValid) {
          let quizData = getValues();
          quizData = {
            ...quizData,
            TotalQuestionCount: quizData.QuestionsList?.length,
          };
          setFormValues((formValues) => {
            return {
              ...formValues,
              addQuiz: {
                ...formValues.addQuiz,
                ...quizData,
              },
            };
          });
          setActiveQuestionIndex((_) => -1);
          setDisableTabsOnValid(true);
        }
      });
      setIsEditQuestion(false);
    }
  };
  const handleSetActiveTab = (id) => {
    if (!isEditQuestion) {
      let updatedQuestion = {
        Question: questionListWatch?.[activeQuestionIndex]?.Question,
        QuestionImage: questionListWatch?.[activeQuestionIndex]?.QuestionImage,
        IsCorrect: "",
        ActiveQuestionType: id,
        MultiSelect: false,
        Explanation: "",
        AnswersList: [
          { Answer: "", AnswerImage: "" },
          { Answer: "", AnswerImage: "" },
        ],
      };
      updateQuestion(
        activeQuestionIndex,
        //   {
        //   Question: questionListWatch?.[activeQuestionIndex]?.Question,
        //   QuestionImage: questionListWatch?.[activeQuestionIndex]?.QuestionImage,
        //   IsCorrect: questionListWatch?.[activeQuestionIndex]?.IsCorrect,
        //   AnswersList: questionListWatch?.[activeQuestionIndex]?.AnswersList,
        //   ActiveQuestionType: id,
        // }
        updatedQuestion
      );
      setActiveTab(() => id);
    }
  };

  const handleDrag = ({ source, destination }) => {
    if (destination) {
      moveQuestion(source.index, destination.index);
    }
  };

  const handleThumbnailSelect = (activeThumbnailName, activeSection = 2) => {
    setActiveThumbnailName(() => activeThumbnailName);
    setActiveSection(() => activeSection);
  };

  const handleDeleteQuizQuestion = (index, questionId) => {
    if (questionId) {
      deleteQuizQuestion(questionId).then((data) => {
        console.log(data);
      });
    }

    removeQuestion(index);
    setActiveTab(1);

    let quizData = getValues();
    quizData = {
      ...quizData,
      PassingMarks: quizData.PassingMarks,
      TotalQuestionCount: quizData.QuestionsList?.length,
    };
    setFormValues((formValues) => {
      return {
        ...formValues,
        addQuiz: {
          ...formValues.addQuiz,
          ...quizData,
        },
      };
    });

    setIsEditQuestion(false);
    setDisableTabsOnValid(false);
    setFormValues((formValues) => {
      return {
        ...formValues,
        disableTabsOnValid: false,
      };
    });
    setActiveQuestionIndex((_) => -1);
  };

  const handleBack = () => {
    if (
      location?.pathname?.includes(
        `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
      ) ||
      location?.pathname?.includes(
        `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`
      )
    )
      navigate(
        `${submisssions.shotClassespath(params, location, tenantName)}/details`
      );
    else {
      if (isValid && saveTrue) {
        let quizData = getValues();
        quizData = {
          ...quizData,
          PassingMarks: quizData.PassingMarks,
          TotalQuestionCount: quizData.QuestionsList?.length,
        };
        setFormValues((formValues) => {
          return {
            ...formValues,
            addQuiz: {
              ...formValues.addQuiz,
              ...quizData,
            },
          };
        });
      }
      setFormValues((formValues) => {
        return {
          ...formValues,
          disableTabsOnValid: true,
        };
      });
      navigate(`${createShotclassesPath}/details`);
    }
  };
  const handleSaveAsDraft = () => {
    dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(true));
    let quizData = getValues();
    if (activeQuestionIndex !== -1) {
      let questionsList = quizData.QuestionsList?.filter(
        (_, index) => index !== activeQuestionIndex
      );
      quizData = {
        ...quizData,
        QuestionsList: questionsList,
        PassingMarks: quizData?.PassingMarks,
        TotalQuestionCount: questionsList?.length,
      };
    } else {
      quizData = {
        ...quizData,
        PassingMarks: quizData?.PassingMarks,
        TotalQuestionCount: quizData.QuestionsList?.length,
      };
    }
    let shotclassData = { ...formValues, addQuiz: quizData };
    if (shotclassType === "edit") {
      dispatch(updateShotclassActionHandler(shotclassData, "Saved"))
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully`
                )
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false)
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    } else if (shotclassType === "copy") {
      dispatch(copyShotclassActionHandler(shotclassData, "Saved"))
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully`
                )
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false)
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    } else {
      dispatch(
        createShotclassActionHandler(
          shotclassData,
          "Saved",
          "LearningContentWithQuizAndSurvey"
        )
      )
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully`
                )
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false)
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    }
  };
  // useEffect(() => {
  //   if (isDirty) setNormalExit(true);
  // }, [setNormalExit, isDirty]);

  // usePrompt("Are you sure you want to leave this page?", normalExit);
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.addQuiz}>
        {activeSection === 1 ? (
          <div className={classes.addQuiz__form}>
            <div className={classes.addQuiz__form__main}>
              <div className={classes.addQuiz__form__main__questionList}>
                <div
                  className={classes.addQuiz__form__main__questionList__heading}
                >
                  Add quiz with answers
                </div>
                <DragDropContext onDragEnd={handleDrag}>
                  <Droppable droppableId="quiz-questions">
                    {(provided, snapshot) => (
                      <AddQuizQuestionArr
                        errors={errors}
                        questionsFields={questionsFields}
                        questionListWatch={questionListWatch}
                        activeQuestionIndex={activeQuestionIndex}
                        setActiveTab={setActiveTab}
                        setActiveQuestionIndex={setActiveQuestionIndex}
                        reference={provided.innerRef}
                        snapshot={snapshot}
                        shotclassType={shotclassType}
                        handleThumbnailSelect={handleThumbnailSelect}
                        isDistributed={formValues?.Other?.IsDistributed}
                        trigger={trigger}
                        isValid={isValid}
                        setIsEditQuestion={setIsEditQuestion}
                        handleDeleteQuizQuestion={handleDeleteQuizQuestion}
                        {...provided.droppableProps}
                      />
                    )}
                  </Droppable>
                </DragDropContext>
                {activeQuestionIndex === -1 ? (
                  !formValues?.Other?.IsDistributed ? (
                    <Button
                      label={"Add New Question"}
                      height="3"
                      width="17.9"
                      icon={PlusIcon}
                      onClick={() => {
                        appendQuestion({
                          Question: "",
                          QuestionImage: {},
                          IsCorrect: "",
                          ActiveQuestionType: 1,
                          MultiSelect: false,
                          Explanation: "",
                          AnswersList: [
                            { Answer: "", AnswerImage: "" },
                            { Answer: "", AnswerImage: "" },
                          ],
                        });
                        setActiveQuestionIndex(
                          () => questionsFields?.length || 0
                        );
                        setIsEditQuestion(false);
                        setDisableTabsOnValid(false);
                        setFormValues((formValues) => {
                          return {
                            ...formValues,
                            disableTabsOnValid: false,
                          };
                        });
                        setActiveTab(() => 1);
                      }}
                      light
                      type="button"
                      disabled={shotclassType === "view"}
                    />
                  ) : (
                    <></>
                  )
                ) : (
                  <Button
                    label={<FormattedMessage id="P_SAVE_TXT" />}
                    height="3"
                    width="15.9"
                    icon={FaSave}
                    onClick={() => {
                      saveQuestion();
                      setSaveTrue(true);
                    }}
                    light
                    type="button"
                    disabled={shotclassType == "view"}
                  />
                )}
                <div
                  className={
                    classes.addQuiz__form__main__questionList__sliderContainer
                  }
                >
                  <div
                    className={
                      classes.addQuiz__form__main__questionList__sliderContainer__heading
                    }
                  >
                    <FormattedMessage id="CREATE_PASSINGPECENT_TEXT" />
                  </div>
                  <Input
                    type={"range"}
                    name={"PassingMarks"}
                    disabled={
                      shotclassType === "view" ||
                      formValues?.Other?.IsDistributed
                    }
                  />
                </div>
              </div>
              {activeQuestionIndex !== -1 && (
                <div className={classes.addQuiz__form__main__answerList}>
                  <div
                    className={classes.addQuiz__form__main__answerList__header}
                  >
                    <TabLinks
                      tabs={answerTabs}
                      activeTab={activeTab}
                      setActiveTab={(id) => {
                        // clearErrors();
                        handleSetActiveTab(id);
                      }}
                    />
                    <div
                      className={classes.addQuiz__form__button__nextButton}
                      onClick={() => {
                        handleSkipQuiz();
                      }}
                    >
                      <div
                        className={
                          classes.addQuiz__form__button__nextButton__linkMedium
                        }
                      >
                        Skip Quiz
                      </div>
                      <PreviousIcon fill={colors.theme} />
                    </div>
                  </div>
                  {questionsFields.map((_, questionIndex) => {
                    return questionIndex === activeQuestionIndex ? (
                      <AddQuizAnswerArr
                        key={_.id}
                        activeQuestionIndex={activeQuestionIndex}
                        control={control}
                        errors={errors}
                        activeTab={activeTab}
                        questionListWatch={questionListWatch}
                        shotclassType={shotclassType}
                        isDistributed={formValues?.Other?.IsDistributed}
                        handleThumbnailSelect={handleThumbnailSelect}
                        trigger={trigger}
                        setValue={setValue}
                      />
                    ) : (
                      <React.Fragment key={_.id}></React.Fragment>
                    );
                  })}
                </div>
              )}
            </div>
            <div className={classes.addQuiz__form__button}>
              <div
                className={classes.addQuiz__form__button__backButton}
                onClick={handleBack}
              >
                <PreviousIcon fill={colors.theme} />
                <div
                  className={
                    classes.addQuiz__form__button__backButton__linkMedium
                  }
                >
                  {/* <FormattedMessage id="DETAILS_TEXT" /> */}
                  Previous
                </div>
              </div>
              <div className={classes.addQuiz__form__button__rightSection}>
                {
                  // shotclassType !== "view" &&
                  // (isDirty || formValues?.addQuiz?.TotalQuestionCount > 0)
                  shotclassType === "create" && (
                    <div
                      className={classes.addQuiz__form__button__linkSmall}
                      onClick={() => handleClearAll()}
                    >
                      <FormattedMessage id="CLEAR_ALL_TXT" />
                    </div>
                  )
                }
                {shotclassType !== "view" &&
                  (shotclassType !== "edit" ||
                    (shotclassType === "edit" &&
                      shotclassTypeFrom === "myDrafts")) &&
                  !location.pathname.includes(
                    moderateContributions.path(tenantName)
                  ) && (
                    <Button
                      label={
                        saveAsADraftLoader ? (
                          "Saving..."
                        ) : (
                          <FormattedMessage id="SAVE_CLASS_TEXT" />
                        )
                      }
                      small
                      dark
                      loading={saveAsADraftLoader}
                      onClick={() => {
                        handleSaveAsDraft();
                        //setNormalExit(false);
                      }}
                    />
                  )}
                <Button
                  // label={nextButtonText}
                  label={"Next"}
                  small
                  dark
                  disabled={!isValid || activeQuestionIndex !== -1}
                  type="submit"
                  //onClick={() => setNormalExit(false)}
                />
              </div>
            </div>
          </div>
        ) : activeSection === 2 ? (
          <SelectThumbnail
            setActiveSection={(val) => {
              setActiveSection(val);
              trigger([`QuestionsList.${activeQuestionIndex}.AnswersList`]);
            }}
            name={activeThumbnailName}
          />
        ) : (
          <></>
        )}
      </form>
    </FormProvider>
  );
};

export default AddQuiz;
